import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from '../../../forms/_common/Overlay';
import FormErrors from '../../../forms/_common/FormErrors';
import RequestError from '../../../forms/_common/RequestError';
import ErrorMessage from '../../../forms/_common/ErrorMessage';
import SolidButton from '../../../components/Button/SolidButton';
import FormTemplate2 from '../../_post-opportunity/FlowTemplate';
import ProjectUpload from './ProjectUpload';
import FormSection from '../../_post-opportunity/forms/FormSection';
import { useConnect, useQueryMutation } from '@lore/query-connect';
import Card from '../../../components/Card';
import UploadImageDestroyable from '../../evaluation-project-educator/Uploads/UploadImageDestroyable';
import UploadDocumentDestroyable from '../../evaluation-project-educator/Uploads/UploadDocumentDestroyable';
import getUploadInfo from '../../evaluation-project-educator/Uploads/getUploadInfo';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    project,
    navigation,
    onNext,
    onPrevious,
    onSkip,
    onExit,
    FormTemplate = FormTemplate2,
    buttonText = 'Next'
  } = props;

  const projectUploads = useConnect('upload.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id
        }
      }
    }
  });

  const [data, setData] = useState(_.pick(project.data, [
    // 'field'
  ]));
  const [showErrors, setShowErrors] = useState(false);
  const [exit, setExit] = useState(false);

  const mutation = useQueryMutation('project.update', project);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      exit ? onExit(data) : onNext(data);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onSubmitAndExit() {
    onSubmit();
    setExit(true);
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  function onUpload(upload) {
    // lore.actions.upload.create({
    //   projectId: project.id,
    //   uploadId: upload.id
    // }).payload
  }

  const projectImages = {
    data: projectUploads.data.filter(function(projectUpload) {
      return getUploadInfo(projectUpload.data.name).isImage;
    })
  };

  const projectDocuments = {
    data: projectUploads.data.filter(function(projectUpload) {
      return !getUploadInfo(projectUpload.data.name).isImage;
    })
  };

  return (
    <Overlay isVisible={saving}>
      <FormErrors data={data} validators={{
        // field: [validators.isRequired]
      }}>
        {({ errors, hasError }) => {
          return (
            <FormTemplate
              onExit={() => hasError ? setShowErrors(true) : onSubmitAndExit()}
              onPrevious={onPrevious}
              navigation={navigation}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : null}
              body={(
                <FormSection
                  // title="Project Documents"
                  // tooltip={(
                  //   <>
                  //     <div className="font-semibold text-cs-gray-900 text-base">
                  //       Examples
                  //     </div>
                  //     <ul className="list-disc ml-6 text-cs-gray-900 text-base">
                  //       {[
                  //         'Informational flyers',
                  //         'Formal application',
                  //         'Photo from a previous year',
                  //         'Student questions',
                  //         'Etc.'
                  //       ].map(function(text, index) {
                  //         return (
                  //           <li key={index}>
                  //             {text}
                  //           </li>
                  //         );
                  //       })}
                  //     </ul>
                  //   </>
                  // )}
                >
                  <div className="space-y-8">
                    <Card className="p-5">
                      <div className="border border-dashed border-cs-orange-500 bg-cs-orange-500 bg-opacity-20 rounded-lg text-center py-20">
                        <ProjectUpload
                          project={project}
                          onUpload={onUpload}
                        />
                      </div>
                    </Card>
                    {projectImages.data.length > 0 && (
                      <FormSection title="Project Images">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {projectImages.data.map(function(projectUpload) {
                            return (
                              <UploadImageDestroyable
                                key={projectUpload.id || projectUpload.cid}
                                upload={projectUpload}
                              />
                            );
                          })}
                        </div>
                      </FormSection>
                    )}
                    {projectDocuments.data.length > 0 && (
                      <FormSection title="Project Documents">
                        <div className="grid grid-cols-1 sm:grid-cols-2x gap-6">
                          {projectDocuments.data.map(function(projectUpload) {
                            return (
                              <UploadDocumentDestroyable
                                key={projectUpload.id || projectUpload.cid}
                                upload={projectUpload}
                              />
                            );
                          })}
                        </div>
                      </FormSection>
                    )}
                  </div>
                </FormSection>
              )}
              footer={(
                <>
                  <SolidButton onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
                    {buttonText}
                  </SolidButton>
                </>
              )}
            />
          );
        }}
      </FormErrors>
    </Overlay>
  );
};
